/**
 * Datentypen der Bestellposition-Eigenschaften — Ersatz für
 * `typeof(OrderPosition).GetProperty(FieldName).PropertyType`.
 *
 * Die Reihenfolge der Schlüssel bestimmt die Feldliste (`orderPositionFieldNames`).
 */

import type { OrderPosition } from '../entities';
import type { ColumnValueType } from '../fieldTypes';
import { baseEntityFieldTypes } from './base';

export const orderPositionFieldTypes: Readonly<Record<keyof OrderPosition, ColumnValueType>> = {
  A0Empfaenger: 'string',
  A0Name1: 'string',
  AbzugReidem: 'number',
  AnkunftsdatumBuchung: 'date',
  AnzahlRgNachlauf: 'integer',
  AnzahlRgSeefracht: 'integer',
  AnzahlRgZoll: 'integer',
  Anzahlung: 'number',
  Artikelgruppe: 'string',
  Artikelnummer: 'string',
  Belegdatum: 'date',
  Belegjahr: 'integer',
  Belegnummer: 'integer',
  BelegnummerBh: 'string',
  BelId: 'integer',
  BelPosId: 'integer',
  Bemerkung: 'string',
  Bezeichnung1: 'string',
  Bezeichnung2: 'string',
  BuchdatumAnz: 'date',
  BuchdatumRest1: 'date',
  BuchdatumRest2: 'date',
  BuchungSage: 'boolean',
  Buchungsperiode: 'number',
  Cbm: 'number',
  CommentPsi: 'string',
  ConfirmedDeliveryDate: 'date',
  Container: 'string',
  ContainerId: 'integer',
  Container_Anlieferdatum: 'date',
  Container_AnlieferdatumEmpf: 'date',
  Container_Anlieferuhrzeit: 'string',
  Container_Bemerkung: 'string',
  Container_BLNummer: 'string',
  Container_Containerleerrueckgabe: 'string',
  Container_ContainerNo: 'string',
  Container_ContTyp1: 'string',
  Container_DatumZugestellt: 'date',
  Container_DepotDatum: 'date',
  Container_DepotName: 'string',
  Container_EingangErledigt: 'boolean',
  Container_Empfaenger: 'string',
  Container_ETA: 'date',
  Container_ETD: 'date',
  Container_FruehestAnlieferdatum: 'date',
  Container_Kw: 'string',
  Container_NaechsteKW: 'boolean',
  Container_Plombe: 'string',
  Container_PoD: 'string',
  Container_RueckgabeReferenz: 'string',
  Container_Schiff: 'string',
  Container_Spediteur: 'string',
  Container_TerminBestaetigungCIF1: 'boolean',
  Demurrage: 'number',
  EinfuhrUst: 'number',
  Einzelpreis: 'number',
  EkInklProvision: 'number',
  EkStkInklProvision: 'number',
  Ereignis: 'string',
  Export: 'boolean',
  Forwarder: 'string',
  FoshanEfRgNr: 'string',
  FoshanRgPos: 'string',
  FrachtjeArtikel: 'number',
  FrachtproStueck: 'number',
  IdLabelDeadline: 'date',
  IdLabelFinal: 'date',
  Incoterm: 'string',
  JahrBuchungBh: 'number',
  KalkEk: 'number',
  KalkEkUebertragen: 'boolean',
  KepVersand: 'boolean',
  Kommentare: 'string',
  KommentarPsi: 'string',
  Label: 'string',
  Lagergeld: 'number',
  LastExported: 'date',
  LayoutErledigt: 'boolean',
  LayoutsChecked: 'boolean',
  Liefertermin: 'date',
  ManualDeadline: 'date',
  ManualFinal: 'date',
  Menge: 'number',
  MonatBuchungBh: 'number',
  MusterQsErledigt: 'boolean',
  Nachlauf: 'number',
  NaechsterTerminLayouts: 'date',
  Order: 'string',
  OrderRecepient: 'string',
  OriginalDeliveryDate: 'date',
  PackagingDeadline: 'date',
  PackagingFinal: 'date',
  PanelDeadline: 'date',
  PanelFinal: 'date',
  PeriodeBuchungBh: 'string',
  PlanEta: 'date',
  PlanEtd: 'date',
  ProvisionYuanfan: 'number',
  PruefmusterQs: 'boolean',
  Psi: 'date',
  PsiReleased: 'boolean',
  PsiReport: 'string',
  RecOrderNo: 'string',
  Restzahlung1: 'number',
  Restzahlung2: 'number',
  SageBuchungDatum: 'date',
  Seefracht: 'number',
  Shipped: 'boolean',
  ShippedDate: 'date',
  ShippingMarksDeadline: 'date',
  ShippingMarksFinal: 'date',
  ShippingStatus: 'string',
  VorId: 'integer',
  VorPosId: 'integer',
  Waehrungskurs: 'number',
  WareWa: 'number',
  WareWaYiyou: 'number',
  WKz: 'string',
  WunschLt: 'date',
  Zoll: 'number',
  ZusatzkostenLogoRmb: 'number',
  ZusatzkostenMOQRmb: 'number',
  ZusatzkostenPreiserhoehungRmb: 'number',
  ZusatzkostenSonstigesRmb: 'number',
  ZusatzkostenWSHRmb: 'number',
  ...baseEntityFieldTypes,
};
